onDomLoad(function () {
  const htmlForm = document.querySelector(
    "[data-behavior='email-notifications-form']"
  )

  if (!htmlForm) {
    return
  }

  class DefaultEmailNotificationsConfigurationsForm {
    #form
    #submitButton
    #currentValue
    #translationsScope = 'user.firm_level_configuration.email_notifications'

    constructor(htmlForm) {
      this.#form = htmlForm
      this.#submitButton = htmlForm.querySelector("input[type='submit']")
      this.#currentValue = this.checkedValue

      this.init()
    }

    init() {
      this.#submitButton.disabled = true
      this.#form.addEventListener('submit', this.onSubmit.bind(this))
      this.#form.addEventListener('change', this.onChange.bind(this))
    }

    get checkedValue() {
      return this.#form.querySelector('input:checked').value
    }

    onSubmit(event) {
      event.preventDefault()

      this.openModal()
    }

    onChange() {
      if (this.#currentValue === this.checkedValue) {
        this.#submitButton.disabled = true

        return
      }

      this.#submitButton.disabled = false
    }

    openModal() {
      window.modalCitizen.openModal(
        'users-configure-email-notifications-confirm-modal',
        {
          form: this.#form,
          newSetting: I18n.t(
            `${this.#translationsScope}.frequencies.${this.checkedValue}`
          ),
          submitButton: this.#submitButton,
        }
      )
    }
  }

  new DefaultEmailNotificationsConfigurationsForm(htmlForm)
})
